import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import { apiURL } from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const SapServiceCallTheTruck = () => {
  const { t } = useTranslation()
  const [Error, setError] = useState(false)
  const [VehicleNumber, setVehicleNumber] = useState(null)
  const [FormData, setFormData] = useState({
    tour: '',
  })

  const [partnerPortalUrl, setPartnerPortalUrl] = useState(null)

  const { data, loading, error } = useAxiosPartnerPortal(
    partnerPortalUrl,
    FormData,
    'post'
  )

  const FormSubmit = (e) => {
    e.preventDefault()
    setPartnerPortalUrl(apiURL('call_the_truck?t=' + FormData.tour))
    return true
  }

  useEffect(() => {
    if (data) {
      // Die Vehicle Nummer kann leer zurückkommen
      if (data.vehicle_number) {
        setVehicleNumber(data.vehicle_number)
      } else {
        setError(true)
      }
    }
  }, [data])

  return (
    <>
      <div className="spa-block-full" data-spa-type="call_the_truck">
        <form onSubmit={(e) => FormSubmit(e)}>
          <div className="mb-1">
            <label htmlFor="tour">{t('generic.spa.tour')}</label>
            <input
              type="text"
              className="form-control"
              name="tour"
              required
              autoFocus
              onChange={(e) =>
                setFormData({
                  ...FormData,
                  tour: e.target.value,
                })
              }
            />
          </div>

          <button className="btn btn-primary btn-sm" type="submit">
            {t('generic.spa.send')}
          </button>
        </form>
      </div>

      {loading && <LoadingSpinner />}

      {VehicleNumber && (
        <div className="spa-block-full mt-2">
          <div data-spa-result-for="call_the_truck" className="">
            <strong>{t('generic.spa.phone_number')}:</strong>
            <a href={`tel:+4917254804${VehicleNumber}`}>
              +4917254804{VehicleNumber}
            </a>
          </div>
        </div>
      )}
      {Error && (
        <div className="spa-block-full mt-2">
          <div data-spa-result-for="call_the_truck" className="">
            <p>{t('generic.spa.no_results')}</p>
          </div>
        </div>
      )}
    </>
  )
}

export default SapServiceCallTheTruck
